import React from "react";
import SectionLabel from "./SectionLabel";

const GROUPS = [
  {
    key: "ai-llm",
    label: "AI & LLM",
    items: [
      "RAG",
      "Prompt Engineering",
      "OpenAI",
      "Anthropic",
      "LangChain",
      "LlamaIndex",
      "ChromaDB",
      "pgvector",
      "Agents",
      "Vector Databases",
      "Langflow",
    ],
  },
  {
    key: "backend",
    label: "Backend",
    items: [
      "Node.js",
      "Express",
      "Postgres",
      "MongoDB",
      "Redis",
      "AZURE",
      "REST APIs",
      "GraphQL",
      "WebSockets",
      "JWT",
    ],
  },
  {
    key: "frontend",
    label: "Frontend",
    items: ["React", "Next.js", "TypeScript", "Tailwind", "ShadCN", "Vite"],
  },
  {
    key: "devops",
    label: "DevOps",
    items: ["Docker", "Kubernetes", "AWS", "GCP", "GitHub Actions", "Nginx", "Linux"],
  },
  {
    key: "ai-automation",
    label: "AI Automation",
    items: [
    "n8n",
    "Langflow",
    "Make",
    "Webhook Workflows",
    "Email Automation",
    "Business Process Automation",
    "Personal AI Agents",
    "Agent Orchestration",
    "Browser Automation",
    ],
  }
];

export const Skills = () => {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="relative border-b border-line"
    >
      <div className="mx-auto max-w-6xl px-6 py-24">
        <SectionLabel index="03" label="STACK" testId="skills-label" />

        <div className="mt-10 grid gap-8 md:grid-cols-12">
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-dim">
              cat ./skills.toml
            </p>
            <p className="mt-3 font-sans text-sm text-ink-secondary">
              Tools I reach for in production. No percentage bars — depth shows
              up in the work, not in a chart.
            </p>
          </div>

          <div className="md:col-span-9">
            <ul className="grid gap-6 sm:grid-cols-2">
              {GROUPS.map((g) => (
                <li
                  key={g.key}
                  data-testid={`skill-group-${g.key}`}
                  className="border border-line bg-bg-surface/40 p-5"
                >
                  <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.22em]">
                    <span className="text-ink-primary">
                      <span className="text-accent">{">"}</span> {g.label}
                    </span>
                    <span className="text-ink-dim">
                      {String(g.items.length).padStart(2, "0")} entries
                    </span>
                  </div>
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {g.items.map((it) => (
                      <span
                        key={it}
                        className="inline-flex items-center border border-line bg-bg-base/60 px-2.5 py-1 font-mono text-[11px] tracking-tight text-ink-secondary transition hover:border-accent/50 hover:text-accent"
                      >
                        {it}
                      </span>
                    ))}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
